import { useManualQuery } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

import { PROMPT_QUERY_MAP } from './utils/promptUtils';

const getQuery = (queryType) => PROMPT_QUERY_MAP[queryType] || PROMPT_QUERY_MAP.article;

function usePromptManualQuery({ promptSlug, queryType = 'smartAssist' }) {
  const query = getQuery(queryType);

  const [runQuery, result] = useManualQuery(query, {
    noThrow: true,
    useCache: true
  });

  useError(result.error);

  const execute = () => runQuery({
    variables: {
      input: { slug: promptSlug }
    }
  });

  return {
    ...result, // data, loading, errors
    // WORKAROUND: Fix loading state issue with cache hits
    //
    // Problem: useManualQuery from @zenbusiness/application-commons-graphql has a bug
    // where loading remains true even when data is served from cache.
    //
    // Root cause: The hook sets inProgressRef.current = true immediately when
    // refetch() is called, but the logic to reset it back to false doesn't
    // always trigger correctly for cache hits, causing loading to get "stuck" at true.
    //
    // This happens because:
    // 1. refetch() always sets inProgressRef.current = true
    // 2. Final loading state = inProgressRef.current (not the original state.loading)
    // 3. Reset logic may not trigger properly when cache hit occurs immediately
    //
    // Solution: Override loading to false when we have a cache hit, since
    loading: result.cacheHit ? false : result.loading,

    execute
  };
}

export { usePromptManualQuery };
